<template>
    <div class="jumbotron" v-if="isShow">
        <loading :active.sync="isLoading" :is-full-page="false"></loading>

        <div class="text-right" v-show="firm.contragent_type === 'LTD'">Тип контрагента: ООО</div>
        <div class="text-right" v-show="firm.contragent_type === 'IP'">Тип контрагента: ИП</div>

        <div>
            <h3 class="mb-2">Реквизиты юридического лица</h3>
            <div class="row">
                <div class="col-6">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">Наименование организации</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" v-model="firm.name">
                            <div :class="{'d-block': validation.firm.name !== '', 'invalid-feedback':true}">{{ validation.firm.name }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">Юридический адрес</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" v-model="firm.organization_juridical_address">
                            <div :class="{'d-block': validation.firm.organization_juridical_address !== '', 'invalid-feedback':true}">{{ validation.firm.organization_juridical_address }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group row required">
                        <label class="col-sm-2 col-form-label">ИНН</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" aria-required="true" v-model="firm.organization_inn">
                            <div :class="{'d-block': validation.firm.organization_inn !== '', 'invalid-feedback':true}">{{ validation.firm.organization_inn }}</div>
                        </div>
                    </div>
                    <div class="form-group row" v-if="firm.contragent_type==='LTD'">
                        <label class="col-sm-2 col-form-label">КПП</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" v-model="firm.organization_kpp">
                            <div :class="{'d-block': validation.firm.organization_kpp !== '', 'invalid-feedback':true}">{{ validation.firm.organization_kpp }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="mb-2">Банковские реквизиты</h3>
            <div class="row">
                <div class="col-6">
                    <div class="form-group row required">
                        <label class="col-sm-2 col-form-label">БИК</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" aria-required="true" v-model="firm.organization_bik">
                            <div :class="{'d-block': validation.firm.organization_bik !== '', 'invalid-feedback':true}">{{ validation.firm.organization_bik }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">Название банка</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" v-model="firm.organization_bank_name">
                            <div :class="{'d-block': validation.firm.organization_bank_name !== '', 'invalid-feedback':true}">{{ validation.firm.organization_bank_name }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group row required">
                        <label class="col-sm-2 col-form-label">Расчетный счет</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" aria-required="true" v-model="firm.organization_bank_account2">
                            <div :class="{'d-block': validation.firm.organization_bank_account2 !== '', 'invalid-feedback':true}">{{ validation.firm.organization_bank_account2 }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">Корр.счет</label>
                        <div class="col-sm-10">
                            <input @change="onFirmUpdate()" type="text" class="form-control" v-model="firm.organization_bank_account1">
                            <div :class="{'d-block': validation.firm.organization_bank_account1 !== '', 'invalid-feedback':true}">{{ validation.firm.organization_bank_account1 }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 text-right">
                    <input type="checkbox" true-value="1" false-value="0" @change="onFirmUpdate()" v-model="firm.use_nds"> с НДС
                </div>
            </div>
        </div>
        <div class="text-danger text-right">{{ message }}</div>

        <div>
            <button class="btn btn--red btn--small mr-2" type="button" @click.prevent="showDelete">Удалить карточку {{ firm.name }}</button>
            <a style="color: #c8242d;" v-if="show_delete_link===true" href="#" @click.prevent="deleteFirm()">Да</a>&nbsp;&nbsp;
            <a v-if="show_delete_link===true" href="#" @click.prevent="hideDelete">Нет</a>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";

    export default {
        name: "OrganizationForm",
        data() {
            return {
                isLoading: false,
                show_delete_link: false,
            }
        },
        computed: {
            firm: function () {
                const firms = this.$store.getters.firms;
                if(typeof firms != 'undefined') {
                    const defaultFirm = firms.filter(firm => firm.default_firm === 1)
                    if (defaultFirm.length) {
                        return defaultFirm[0];
                    }
                }
                return undefined;
            },
            isShow() {
                return this.$store.getters.pay_type === '3' && typeof this.firm != 'undefined';
            },
            message: function () {
                return this.$store.getters.current_message;
            },
            validation: function () {
                return this.$store.getters.validation;
            }
        },
        methods: {
            onFirmUpdate: function() {
                this.isLoading = true;
                this.$store.dispatch("updateFirm", this.firm).then(response => {
                    this.isLoading = false;
                });
            },
            showDelete () {
                this.show_delete_link = true;
            },
            hideDelete () {
                this.show_delete_link = false;
            },
            deleteFirm: function () {
                this.isLoading = true;
                this.hideDelete();

                this.$store.dispatch("deleteFirm", this.firm).then(response => {
                    this.isLoading = false;
                });
            }
        },
        components: {
            Loading,
        },
    }
</script>

<style scoped>

</style>
